/**
 * Six-character reference shown to the user and stored on the Monitoring
 * event, so a support call ("it said ref 7K2QX9") lands on the exact
 * occurrence — with the raw text, stack, page and user intact.
 *
 * Per occurrence, not per problem: two users hitting the same bug get
 * different refs, and each ref identifies one event.
 */
export function newRef() {
  return Math.random().toString(36).slice(2, 8).toUpperCase().padEnd(6, "0");
}
